export type Integer = number;

export type IntegerString = string;

export type Long = number;

export type LongString = string;

export type Double = number;

export type DoubleString = string;

export type CurrencyFloat = number;

export type CurrencyFloatString = string;

export type CurrencyNumber = number;

export type CurrencyString = string;

export type CurrencyCode = string;

export type PercentageFloat = number;

export type PercentageFloatString = string;

export type PercentageInteger = number;

export function asNumber<T>(value: T): number {
    return value as any as number;
}

export function parseIntOrUndefined(value: string): number | undefined {
    const parsedValue = parseInt(value, 10);
    if (isNaN(parsedValue)) {
        return undefined;
    } else {
        return parsedValue;
    }
}
